export default {
    //基础通用
    base: {
        look: "Look More",
        select: "请选择",
    },
    //layout
    route: {
        home: "首页",
        technology: "TECHNOLOGY",
        products: "PRODUCTS",
        visaItems: "签证项目",
        contacts: "关于我们",
        faq: "常问问题",
    },
    home: {
        homeTitle1: "经验",
        homeTilte2: "是我们的实力",
        homeTilte3: "诚信",
        homeTilte4: "是我们的准则",
        homeTilte5: "公司介绍",
        homeTilte6: "签证项目",
        page1Text: "强盛移民公司即强盛集团（KRNG PARTNERS MELBOURNE PTY 0960241 2016 年正式成立，致力于为澳洲新老移民和即将踏入澳洲这片土地的华人朋友们提供便捷的高效的移民服务。我们的服务涉猎广泛，公司坐落于墨尔本东南区博士山黄金地段。无论您在澳洲境内还是境外，在本公司的协助下，语言地理位置将不再是您寻求发展的阻碍。我们的团队将真正做到知您所需，为您排忧！",
        page2Title1: "188A 创业类",
        page2Text1: "55岁以下或州政府豁免年龄要求；评分达到65 <br/> 分或以上；3年以上管理生......",
        page2Title2: "188B 投资类",
        page2Text2: "55岁以下或州政府豁免年龄要求；评分达到65 <br/> 分或以上；3年以上管理生......",
        page2Title3: "188C 重大投资类",
        page2Text3: "无年龄、英语、打分要求；无经商管理背景要求；<br/> 证明合法拥有500万澳……",
        page2Title4: "132  商业天才签证",
        page2Text4: "成功的经商管理背景，参与公司日常管理；过去 <br/> 4年中有2年，在公司中......",
        page2Title5: "888A/B/C  永居签证",
        page2Text5: "188A/B/C 临时居住签证的申请者，在满足转永居 <br/> 条件后可以申请888……",
        page2Title6: "GTI  全球人才项目",
        page2Text6: "Global Talent Independent (GTI) Program…",
        page4Title1: "移民简介",
        page4Text1: "强盛移民公司（KRNG PARTNERS MELBOURNE PTY LTD）是以投资移民类别服务为核心板块，由持牌移民代理负责各类投资移民等签证申请，并协助客户对接澳洲移民局/州政府等相关部门确认生意计划等事宜。本公司有丰富的经验和认真严谨的工作态度，注重诚信和效率，并在成立至今保持着超高的申请通过率。本公司承诺，在遵守澳洲移民代理行为守则的原则下，会尽可能用简易、可行的办法协助您沟通联系，高效地协助您解决相关移民问题。",
        page4Title2: "移民代理行为守则",
        page4Title3: "Consumer Guide",
    },
    visaItems: {
        // checklist:"",
        // Label1:"",
        list1Title1: "要获得商业创新流188签证的资格，您必须：",
        list1Text1: "年龄在55岁以下",
        list1Text2: "得分至少65分",
        list1Text3: "有在澳大利亚企业担任管理职务的真正意愿",
        list1Text4: "有至少125万澳元的净业务和个人资产可合法转让给澳大利亚",
        list1Text5: "在4个会计年度中至少有2个会计年度（在申请签证时）拥有已成立企业或营业额为750000澳元的企业的所有权权益",
        list1Text6: "至少拥有以下任一指定主营业务的百分比：",
        list1Text7: "如果业务年营业额低于40万澳元，则为51%",
        list1Text8: "如果业务营业额为40万澳元或以上，则为30%",
        list1Text9: "如果企业是上市公司，则为10%",

        // Label2:"",
        list2Title1: "要获得投资者流下188签证的资格，您必",
        list2Text1: "年龄在55岁以下（如果拟议投资为提名州或地区提供了突出的经济利益，则可以免除这一要求）。",
        list2Text2: "在点测试中至少达到65分",
        list2Text3: "具备高水平的管理技能，能够从事合格的商业活动",
        list2Text4: "一旦原始投资到期，承诺继续在澳大利亚开展业务和投资",
        list2Text5: "有在指定投资所在州或地区停留至少2年的真实意愿",
        list2Text6: "直接参与管理一个或多个合格企业或合格投资至少3年",
        list2Text7: "在五个财政年度中至少有一个财政年度内，您（与您的合作伙伴）拥有至少10%的合资格企业所有权权益或至少250万澳元的合资格投资",
        list2Text8: "持续投资250万澳币,来源必须为之前赚取的资金,其中：",
        list2Text8_1: "20%用于风险投资(50W AUD)",
        list2Text8_2: "30%用于新兴企业领域(75W AUD)",
        list2Text8_3: "50%用于平衡投资(125W AUD)",
        list2Text9: "已合法获得投资、净业务和个人资产至少250万澳元，以便在获得签证后两年内合法转移至澳大利亚",
        list2Text10: "在澳大利亚没有参与或参与不可接受的活动",

        // Label3:"",
        list3Title1: "你必须真正致力于：",
        list3Text1: "停留在指定的州或地区",
        list3Text2: "即使您的临时签证有效期到期，也要保持您在澳大利亚的业务和投资活动",
        list3Text3: "您、您的合伙人或双方拥有至少500万澳元的净资产，这些资产是合法获得的，可用于在澳大利亚进行合规投资",
        list3Text4: "您一定没有参与或参与过令人遗憾的业务或投资活动",
        list3Text5: "您和您家庭单位的所有受扶养成员（年满18岁）必须提供保证，在发生与合规投资有关的任何损失时，不会对联邦采取任何行动",
        list3Text6: "根据澳大利亚税法，在澳大利亚进行合规投资所得的所有收入必须纳税",
        list3Text7: "您的合规投资或合规重大投资必须在四年内至少达到500万澳元",
        list3Text8: "您的重大投资应按以下比例进行：",
        list3Text9: "至少100万澳元的风险投资和成长型私募股权基金，用于投资初创企业和小型私人公司",
        list3Text10: "投资于在澳大利亚证券交易所上市的新兴公司的核准管理型基金至少150万澳元",
        list3Text11: "至少250万澳元的管理型基金，投资于一系列资产，包括澳大利亚证券交易所上市公司或澳大利亚公司债券、商业房地产和年金",

        // Label4:"",
        list4Title1: "要获得888签证的资格，您必须：",
        list4Text1: "持有临时商业创新和投资签证（188子类），并符合您首次申请的所有要求或",
        list4Text2: "是188签证在投资者或商业创新流中的配偶或事实上的合作伙伴，能够满足相关流中永久性商业创新和投资签证的主要要求或持有特殊类别签证（444子类），符合商业创新流的要求",
        list4Text3: "持有特殊类别签证（子类别 444）并满足商业创新流的要求",
        list4Text4: "未参与或参与任何不可接受的业务或投资活动",
        list4Text5: "保持良好的记录，遵守联邦法律以及国家或地区，你经营业务或创业活动",
        list4Text6: "由澳大利亚州或地区或澳大利亚贸易委员会代表澳大利亚政府提名",
        list4Text7: "符合188签证的健康和性格要求的证据",
        list4Text8: "真正致力于在澳大利亚维持业务或投资活动",
        list4Text9: "符合你持有188签证的所有要求",
        list4Text10: "必须免除对澳大利亚政府的任何未偿债务（这也适用于家庭单位的所有成员），您必须在获得此签证后的指定日期进入澳大利亚",
        list4Text11: "一旦您获得此签证，您必须在指定日期前进入澳大利亚",
        list4Text12: "申请表中的任何家庭成员在进入澳大利亚之前不得结婚或有事实上的关系",

        Label6: "GTI 全球人才项目",
        list6Title5: "专业领域",
        list6Text1: "行业中的优秀人才",
        list6Text2: "需有提名人",
        list6Text3: "学历要求：目标领域内的硕士或博士",
        list6Text4: "年收入153,600澳元（根据不同学历会有所不同，详情可咨询桂冠专业团队）",
        list6Text5: "预约咨询顾问评估",
        list6Text6: "签订委托办理合同",
        list6Text7: "EOI 州担保意向申请",
        list6Text8: "获得GTI 唯一识别码",
        list6Text9: "签证办理",
        list6Text10: "收到移民局补充材料通知",
        list6Text11: "体检",
        list6Text12: "获批GTI签证",
        list6Text13: "中介服务费+第三方服务费",
        list6Text14: "无年龄限制",
        list6Text15: "无需职业评估",
        list6Text16: "无需资产证明和个人资金来源解释",
        list6Text17: "无需排期，审理速度快（约1-2个月即可获得澳洲绿卡）",
        list6Text18: "无英语要求",
        list6Text19: "一人申请，全家绿卡",
        list6Text20: "Resources 资源产业；",
        list6Text21: "Agri-food and AgTech 农业食品及农业科技产业；",
        list6Text22: "Energy 能源产业；",
        list6Text23: "Health industries 医疗健康产业；",
        list6Text24: "Defence, advanced manufacturing and space 国防、先进制造和航天；",
        list6Text25: "Circular economy 循环经济；",
        list6Text26: "Digitech 数字技术；",
        list6Text27: "Infrastructure and tourism 基础设施和旅游；",
        list6Text28: "Financial services and FinTech 金融服务和金融科技；",
        list6Text29: "Education 教育类。",
    },
    contact: {
        page1Title: "我们运用LARK <br/> 来进行管理和沟通",
        title: "联系我们",
        title1: "网址",
        text1: "www.giant-partners.com",
        title2: "邮箱",
        text2: "info@giant-partners.com",
        title3: "地址",
        text3: "Suite 5A/10-12 Prospect St Box Hill,VIC 3128",
        text4: "Suite 5A/10-12 Prospect St Box Hill,VIC 3128",
        tableText1: "预约",
        tableText2: "请填好以下表格，填好后我们的职员会尽快联系你",
        tableText3: "全名",
        tableText4: "电话",
        tableText5: "电邮",
        tableText6: "其它信息/问题",
        tableText7: "你所提交的信 <br/> 息都会被保密",
        submit: "递交",
        /* 新加 */
        tableText8: "标题",
        tableText9: "城市",
        tableText10: "国家/地区",
        tableText11: "推荐人",
        tableText12: "期望的响应时间范围",
        tableText13: "问题类别",
        tableText14: "首选沟通方式",
        tableText15: "先生",
        tableText16: "女士",
        tableText17: "非常紧急",
        tableText18: "紧急",
        tableText19: "一般",
        tableText20: "188ab",
        tableText21: "188c",
        tableText22: "888a",
        tableText23: "888b",
        tableText24: "888c",
        tableText25: "其他",
        tableText26: "书面",
        tableText27: "声音",
        tableText28: "视频",
    },
    messages: {
        errorName: "请输入全名",
        errorIphone: "请输入电话",
        errorEmail: "请输入电邮",
        error1: "请输入合法的手机号",
        error2: "请输入合法的邮箱",
    },
    footer: {
        rights: "©2022 强盛集团.All rights reserved. ",
    },
};